import { NoDuedateCredit } from "@/types/api/merchant/merchant.type";
import {numberSeparator,toPersianNumber,} from "@/hooks/useThousandsSeparator";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import moment from "jalali-moment";
/**
 * ContentModal
 *
 * نمایش جزئیات تراکنش بدون تاریخ سررسید.
 *
 * ویژگی‌ها:
 * - نمایش مبلغ خرید به صورت جداگانه و فرمت شده با ریال
 * - نمایش تاریخ خرید و تاریخ واریز به فرمت شمسی
 * - نمایش مبلغ واریزی به کیف پول قابل برداشت
 * - نمایش شماره کیف پول مشتری و در صورت عدم وجود، نمایش "-"
 * - نمایش درگاه پرداخت مورد استفاده
 *
 * پارامترها:
 * @param dataModal - اطلاعات تراکنش بدون تاریخ سررسید (NoDuedateCredit)
 *
 * @returns JSX.Element
 */

const ContentModal = ({ dataModal }: { dataModal: NoDuedateCredit }) => {
  return (
    <StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">مبلغ خرید</TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          {numberSeparator(dataModal?.amount)}
          <span className="mr-1">ریال</span>
        </TypoGraphyKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">تاریخ خرید</TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          {toPersianNumber(
            moment(dataModal?.created_at.split(" ")[0]).locale("fa").format("YYYY/MM/DD")
          )}
        </TypoGraphyKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">
          مبلغ واریزی به کیف پول قابل برداشت طبق قرارداد
        </TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          {numberSeparator(dataModal?.credit)}
          <span className="mr-1">ریال</span>
        </TypoGraphyKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">تاریخ واریز</TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          {" "}
          {toPersianNumber(
            moment(dataModal?.deposit_date.split(" ")[0]).locale("fa").format("YYYY/MM/DD")
          )}
        </TypoGraphyKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">شماره کیف پول مشتری</TypoGraphyKit>
        <TypoGraphyKit variant="body1" dir="ltr">
          {dataModal.card_id ? toPersianNumber(dataModal.card_id) : "-"}
        </TypoGraphyKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"row"}>
        <TypoGraphyKit variant="body1">خرید از طریق</TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          {" "}
          {dataModal.gateway ? dataModal.gateway : "-"}
        </TypoGraphyKit>
      </StackKit>
    </StackKit>
  );
};

export default ContentModal;
